<template>
    <div id="app">
        <div class="main-wrapper container">
            <Navbar iconAction="0"></Navbar>
            <div class="main-content">
                <button id="show-modal" @click="showModal= !showModal">Show Modal {{ showModal }}</button>
                <button id="show-modal" @click="setPIPL('general')">general</button>
                <button id="show-modal" @click="setPIPL('minor')">minor</button>
                <piplprompt :submit-modal="()=>{ showModal= false}" v-if="showModal"></piplprompt>
                <button class="btn btn-primary m-2" :disabled="isSubmittable" id="btnSubmit">{{
                    $t('Continue')
                    }}
                </button>
                <div class="form-group col-md-5">
                    <label for="name" class="control-label">Country Code</label>
                    <input type="text" name="name" class="form-control" id="country_code" ref="country_code"
                           v-model="country_code" value="" :placeholder="'+86'"/>
                </div>
                <div class="form-group col-md-5">
                    <label for="name" class="control-label">Email</label>
                    <input type="text" name="name" class="form-control" id="email" ref="email"
                           v-model="email" value="" :placeholder="'testing@qq.com'"/>
                </div>
                <button id="show-modal" @click="checkPipl">Check pipl {{ needConsent }}</button>
            </div>
        </div>
    </div>
</template>
<script>
import piplprompt from "@/components/pipl-k11.vue";
import Navbar from "@/components/Navbar.vue";
import {mapGetters, mapMutations} from "vuex";

export default {
    components: {piplprompt, Navbar},
    computed: {
        ...mapGetters(['getPipl', 'isSubmittable']),
    },
    methods: {
        ...mapMutations(['setPIPL']),
        async checkPipl() {
            console.log("checkPipl");
            const response = await fetch("/migrationhub/checkPIPL", {
                method: "POST", headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }, body: JSON.stringify({
                    "countryCode": this.country_code.replace(/^\+/, ''),
                    "email": this.email
                })
            });
            const {needConsent} = await response.json();
            this.needConsent = needConsent;
            console.log("checkPipl", needConsent);
        }
    },
    data() {
        return {
            country_code: "+86",
            email: "testing@gmail.com",
            needConsent: false,
            showModal: false
        };
    },
}
</script>

<style scoped>

</style>
